import React from "react";
import { Check, CheckCircle, Edit2, RotateCcw, UserPlus, X, XCircle } from "lucide-react";

/**
 * Action verb bar (workflow doc v1.4): exposes the user's possible NEXT moves
 * as named verbs (Assign, Modify, Complete, Cancel, Approve, Reject, Reopen,
 * Close) instead of just a status dropdown. Each verb maps to a state
 * transition the caller knows how to perform.
 *
 * Props:
 *   actions: array of action descriptors:
 *     { key: 'assign'|'modify'|'complete'|... , label, onClick, icon?, danger?, disabled? }
 */
const PRESET_ICONS = {
  assign: UserPlus,
  modify: Edit2,
  complete: CheckCircle,
  cancel: XCircle,
  approve: Check,
  reject: X,
  reopen: RotateCcw,
  close: CheckCircle,
};

export default function ActionBar({ actions = [] }) {
  if (!actions.length) return null;
  return (
    <div className="card p-4">
      <div className="text-sm font-semibold mb-2 text-gray-700">Action</div>
      <div className="flex flex-wrap gap-2">
        {actions.map((a) => {
          const Icon = a.icon || PRESET_ICONS[a.key] || Check;
          const cls = a.danger
            ? "bg-red-600 hover:bg-red-700 text-white"
            : a.primary
            ? "bg-brand-500 hover:bg-brand-600 text-white"
            : "bg-white hover:bg-gray-50 border border-gray-300 text-gray-800";
          return (
            <button
              key={a.key}
              type="button"
              disabled={a.disabled}
              onClick={a.onClick}
              className={`${cls} px-3 py-1.5 rounded text-sm font-medium flex items-center gap-1.5 transition ${a.disabled ? "opacity-40 cursor-not-allowed" : ""}`}
              title={a.title || a.label}
            >
              <Icon size={14} />
              {a.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
